import { useTranslation } from 'react-i18next'
import { useContext, useEffect, useState } from 'react'
import { ProjectContext } from '../../../../contexts'
import api from '../../../../api'
import RadioInput from '../../../../ui/form/RadioInput'
import type { ChannelConfig, CreateOptionsProps, CreateTemplateFn } from '../TemplateCreateModal'

const TextCreateOptions = ({ form }: CreateOptionsProps) => {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)
    const [hasRCS, setHasRCS] = useState(false)

    useEffect(() => {
        api.providers.all(project.id)
            .then((providers) => setHasRCS(providers.some(p => p.group === 'text' && p.features?.rcs)))
            .catch(() => {})
    }, [project.id])

    if (!hasRCS) return null

    return (
        <RadioInput.Field
            form={form}
            name="data.editor"
            label={t('text_message_format')}
            options={[
                { key: 'simple', label: t('simple') },
                { key: 'interactive', label: t('interactive') },
            ]}
        />
    )
}

const textCreateTemplate: CreateTemplateFn = async ({ data, initialData }) => {
    if (data?.editor === 'interactive') {
        return {
            data: {
                ...initialData,
                editor: 'interactive',
                rcs: {
                    mode: 'rich_card',
                    suggestions: [],
                    rich_card: {
                        card_orientation: 'VERTICAL',
                        card_content: {
                            title: '',
                            description: '',
                            media: { file_url: '', height: 'MEDIUM' },
                        },
                    },
                },
            },
        }
    }
    return { data: initialData }
}

export const textChannel: ChannelConfig = {
    CreateOptions: TextCreateOptions,
    createTemplate: textCreateTemplate,
}
